import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between mb-6 md:mb-8">
      <div className="relative pl-4">
        <span className="absolute left-0 top-1 bottom-1 w-1 rounded-full bg-primary-500" />
        {eyebrow && (
          <p className="text-xs md:text-sm font-medium tracking-[0.2em] text-primary-600 uppercase mb-1">
            {eyebrow}
          </p>
        )}
        <h2 className="text-xl md:text-3xl font-bold text-foreground-950 leading-tight">{title}</h2>
        {desc && <p className="mt-2 text-sm md:text-base text-foreground-600 max-w-2xl">{desc}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}